<p-button
    icon="pi pi-undo"
    [rounded]="true"
    [text]="true"
    [pTooltip]="l('::Revert')"
    tooltipPosition="right"
    severity="danger"
    (onClick)="onClick()">    
</p-button>